import { NoteAddOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import QuickActionButton from "../shared/QuickActionButton";

const QuickActionSubmitFinancingRequest = ({ children }) => {
  const navigate = useNavigate();
  return (
    <QuickActionButton
      title="Submit New Financing Request"
      description="Start a new financing request for your next project."
      // description="Start a new financing request to get funding."
      icon={<NoteAddOutlined className="thin" />}
      onClick={() => navigate("/financing-request/create")}
    />
  );
};

export default QuickActionSubmitFinancingRequest;
